import { takeLatest, put, delay } from 'redux-saga/effects';
import types from '../../../constants/action-types';
import {
  setgroups,
  setCategories,
  setRegions,
  setUsers,
  setLoading,
  setObjects,
} from './actions';
import groups from '../../../services/groups';
import regions from '../../../services/regions';
import categories from '../../../services/categories';
import users from '../../../services/users';
import objects from 'services/objects';

function* fetchData({ payload }) {
  try {
    yield put(setLoading(true));
    const groupsData = yield groups.getAll();
    yield put(setgroups(groupsData));
    if (payload === 'groupleader') {
      const catsData = yield categories.getAllByGroups();
      yield put(
        setCategories(
          catsData.sort((a, b) => {
            return a._id.toString().localeCompare(b._id.toString());
          })
        )
      );
    } else {
      const catsData = yield categories.getAll();
      yield put(setCategories(catsData));
    }
    const regionsData = yield regions.getAll();
    yield put(setRegions(regionsData));

    const objectsData = yield objects.getAllSubsList({ all: true });
    yield put(setObjects(objectsData));

    const usersData = yield users.getAll();
    yield put(setUsers(usersData));
    yield put(setLoading(false));
  } catch (error) {
    yield put(setLoading(false));

    console.log('error', error);
  }
}

export default function* commonsSaga() {
  yield takeLatest(types.APPLICATION_FETCH_COMMONS_DATA, fetchData);
}
